import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_VOUCHER_SORTABLE, VOUCHER_TYPES } from '../vocabulary'
import { ACTIVITY, voucherQuery, vouchersQuery } from './queries'

const voucherSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_VOUCHER_SORTABLE, [], ['campaign_id'], {
    voucher_type: VOUCHER_TYPES,
    active: ACTIVITY,
  })

export const vouchersRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('vouchers'),
  path: '/vouchers',
  validateSearch: voucherSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(vouchersQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'VouchersPage'),
})

export const voucherRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('vouchers'),
  path: '/vouchers/$id',
  validateSearch: voucherSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(voucherQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'VoucherPage'),
})

export const voucherRoutes = [vouchersRoute, voucherRoute]
